module.exports = __webpack_public_path__ + "img/ca9a80b.png";